import * as React from "react";
import ReminderNotification from "../../../../model/notification/reminder/ReminderNotification";
import LeadHistoryNotification from "../../../../model/notification/lead/LeadStatusNotification";
import NotificationHistoryItem from "./items/NotificationLeadStatusItem";
import LeadWatcherChangeNotification from "../../../../model/notification/watcher/LeadWatcherChangeNotification";
import AssigneeChangeNotification from "../../../../model/notification/assignee/AssigneeChangeNotification";
import NotificationLeadAssigneeItem from "./items/NotificationLeadAssigneeItem";
import NotificationLeadWatcherItem from "./items/NotificationLeadWatcherItem";
import NewThirdPartyLeadNotification from "../../../../model/notification/thirdPartyLead/NewThirdPartyLeadNotification";
import NotificationNewThirdPartyLeadItem from "./items/NotificationNewThirdPartyLeadItem";
import NotificationReminderItem from "./items/NotificationReminderItem";
import {Dispatch} from "redux";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import {
	markAllAsRead,
	markNotificationsAsRead,
	markNotificationsAsUnread
} from "../../../../store/action/notification/notifications";
import Toast from "../../../helper/Toast";
import SmsNotification from "../../../../model/notification/sms/SmsNotification";
import IncomingSmsNotificationItem from "./items/IncomingSmsNotificationItem";
import NotificationBase, {NotificationType} from "../../../../model/notification/NotificationBase";
import QuoteCommentNotification from "../../../../model/notification/quote/QuoteCommentNotification";
import QuoteCommentCreatedItem from "./items/QuoteCommentCreatedItem";
import QuoteStatusChangedNotification from "../../../../model/notification/quote/QuoteStatusChangedNotification";
import QuoteStatusChangedItem from "./items/QuoteStatusChangedItem";
import UserMentionNotification from "../../../../model/notification/mention/UserMentionNotification";
import UserMentionItem from "./items/UserMentionItem";
import NotificationBDPChangedItem from "./items/NotificationBDPChangedItem";
import NotificationAgentChangeItem from "./items/NotificationAgentChangeItem";
import JobUserMentionNotification from "../../../../model/notification/mention/JobUserMentionNotification";
import JobUserMentionItem from "./items/JobUserMentionItem";
import NotificationJobReminderItem from "./items/NotificationJobReminderItem";
import JobReminderNotification from "../../../../model/notification/reminder/JobReminderNotification";
import JobStatusNotification from "../../../../model/notification/job/JobStatusNotification";
import NotificationJobStatusItem from "./items/NotificationJobStatusItem";
import LeadBDPChangeNotification from "../../../../model/notification/assignee/LeadBDPChangeNotification";
import JobBDPChangeNotification from "../../../../model/notification/assignee/job/JobBDPChangeNotification";
import NotificationJobBDPChangedItem from "./items/NotificationJobBDPChangedItem";
import JobAgentChangeNotification from "../../../../model/notification/assignee/job/JobAgentChangeNotification";
import NotificationJobAgentChangedItem from "./items/NotificationJobAgentChangedItem";
import LeadAgentChangeNotification from "../../../../model/notification/assignee/LeadAgentChangeNotification";
import JobWatcherChangeNotification from "../../../../model/notification/watcher/JobWatcherChangeNotification";
import NotificationJobWatcherItem from "./items/NotificationJobWatcherItem";
import JobCreatedFromQuoteNotification from "../../../../model/notification/job/JobCreatedFromQuoteNotification";
import NotificationJobCreatedFromQuoteItem from "./items/NotificationJobCreatedFromQuoteItem";
import "./notificationDropdown.scss";
import "./items/notificationItem.scss";
import Loading from "../../../ui/loading/Loading";
import {api} from "../../../../api/api";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import * as moment from 'moment';
import InvoiceCreatedNotification from "../../../../model/notification/invoice/InvoiceCreatedNotification";
import NotificationInvoiceCreatedItem from "./items/NotificationInvoiceCreatedItem";
import BillCreatedNotification from "../../../../model/notification/invoice/BillCreatedNotification";
import NotificationBillCreatedItem from "./items/NotificationBillCreatedItem";
import PaymentArrivedNotification from "../../../../model/notification/payment/PaymentArrivedNotification";
import NotificationPaymentArrivedItem from "./items/NotificationPaymentArrivedItem";
import InvoicePaidNotification from "../../../../model/notification/invoice/InvoicePaidNotification";
import NotificationInvoicePaidItem from "./items/NotificationInvoicePaidItem";
import NotificationBillPaidItem from "./items/NotificationBillPaidItem";
import BillPaidNotification from "../../../../model/notification/invoice/BillPaidNotification";

/**
 * Notifications filter state.
 */
export enum FilterState {
	All = "all",
	Read = "read",
	Unread = "unread"
}

interface IComponentProps {
	/**
	 * Notification list.
	 */
	notifications: Array<NotificationType>
	/**
	 * Item click handler.
	 */
	onItemLinkClick: () => void;
	/**
	 * Dropdown open indicator.
	 */
	isOpen: boolean;
}

interface IDispatchProps {
	/**
	 * Mark all notification as read.
	 */
	markAllAsRead: (visibleFrom: moment.Moment, onSuccess: OnSuccess) => void;
	/**
	 * Mark notification as read.
	 */
	markReadNotification: (notificationId: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;

	/**
	 * Mark notification as unread.
	 */
	markUnreadNotification: (notificationId: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface State {
	filter: FilterState,
	notifications: NotificationBase[],
	page: number,
	totalItems: number
	isLoading: boolean
}

type Props = IComponentProps & IDispatchProps

class NotificationDropdown extends React.Component<Props, State> {
	PAGE_SIZE = 20
	visibleFrom: moment.Moment;

	constructor(props: Props) {
		super(props);
		this.state = {
			filter: FilterState.All,
			notifications: this.props.notifications.sort(NotificationBase.compare),
			page: 0,
			totalItems: 0,
			isLoading: false
		};
		this.markAllNotificationsAsRead = this.markAllNotificationsAsRead.bind(this);
		this.visibleFrom = moment();
	}

	componentDidMount() {
		this.loadMore();
	}

	render() {
		return (
			<React.Fragment>
				{this.renderFilter()}
				<div className={"c-notification-menu_dropdown_body"}
					 onScroll={this.onScroll}>
					{this.renderNotifications()}
					<Loading isLoading={this.state.isLoading} spinnerSize={40}/>
				</div>
			</React.Fragment>
		);
	}

	onScroll = (e: React.SyntheticEvent<HTMLDivElement>) => {
		if ((e.currentTarget.scrollHeight - (e.currentTarget.clientHeight + e.currentTarget.scrollTop)) < 200) {
			(this.state.totalItems - (this.state.page * this.PAGE_SIZE)) > 0 && this.loadMore()
		}
	}

	loadMore = () => {
		if (!this.state.isLoading) {
			this.setState({isLoading: true}, () => {
				api.instance.notificationApi.fetchNotifications(this.state.page, this.state.filter, this.visibleFrom).then(
					data => {
						this.setState(
							{
								notifications: this.state.page == 0 ? data.items : this.state.notifications.concat(data.items),
								totalItems: data.totalItems,
								page: this.state.page + 1,
								isLoading: false
							})
					}).catch(e => {
					notifyBugsnagAndShowToast(e, "Fetch notifications");
					this.setState({isLoading: false})
				})
			})
		}
	}

	/**
	 * Render filter menu.
	 * @returns {JSX.Element}
	 */
	renderFilter() {
		return (
			<div className="c-notification-menu_dropdown_header">
				<span className={this.state.filter === FilterState.All ? "active" : ""}
					  onClick={() => this.setFilter(FilterState.All)}>ALL</span>
				<span className={this.state.filter === FilterState.Unread ? "active" : ""}
					  onClick={() => this.setFilter(FilterState.Unread)}>UNREAD</span>
				<span className={this.state.filter === FilterState.Read ? "active" : ""}
					  onClick={() => this.setFilter(FilterState.Read)}>READ</span>
				<span className="mark-all-as-read" onClick={this.markAllNotificationsAsRead}>Mark all as read</span>
			</div>
		);
	}

	/**
	 * Set notification filter.
	 * @param filter
	 */
	setFilter(filter: FilterState) {
		if (this.state.filter != filter) {
			this.visibleFrom = moment();
			this.setState({filter, page: 0, notifications: this.filterNotifications(filter)}, this.loadMore);
		}
	}

	/**
	 * Filter notification by read flag.
	 * @param {FilterState} filter Filter state.
	 * @returns {Array<notification>}
	 */
	filterNotifications(filter: FilterState) {
		switch (filter) {
			case(FilterState.All):
				return this.state.notifications;
			case(FilterState.Read):
				return this.state.notifications.filter(n => n.read);
			case(FilterState.Unread):
				return this.state.notifications.filter(n => !n.read);
			default:
				return this.state.notifications;
		}
	}

	/**
	 * Render notifications.
	 * @return {Array<JSX.Element>}
	 */
	renderNotifications(): Array<JSX.Element> {
		const notifications = this.state.notifications
		if (notifications.length) {
			return notifications.map((notification: NotificationType) => {
				const index = notification.id
				if (notification instanceof ReminderNotification) {
					return (
						<NotificationReminderItem key={index}
												  notification={notification}
												  onItemLinkClick={this.props.onItemLinkClick}
												  markReadNotification={this.markReadNotification}
												  markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof LeadHistoryNotification) {
					return (
						<NotificationHistoryItem key={index}
												 notification={notification}
												 markReadNotification={this.markReadNotification}
												 markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof AssigneeChangeNotification) {
					return (
						<NotificationLeadAssigneeItem key={index}
													  notification={notification}
													  markReadNotification={this.markReadNotification}
													  markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof LeadBDPChangeNotification) {
					return (
						<NotificationBDPChangedItem key={index}
													notification={notification}
													markReadNotification={this.markReadNotification}
													markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof LeadAgentChangeNotification) {
					return (
						<NotificationAgentChangeItem key={index}
													 notification={notification}
													 markReadNotification={this.markReadNotification}
													 markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof LeadWatcherChangeNotification) {
					return (
						<NotificationLeadWatcherItem key={index}
													 notification={notification}
													 markReadNotification={this.markReadNotification}
													 markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof NewThirdPartyLeadNotification) {
					return (
						<NotificationNewThirdPartyLeadItem key={index}
														   notification={notification}
														   markReadNotification={this.markReadNotification}
														   markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof SmsNotification) {
					return (
						<IncomingSmsNotificationItem key={index}
													 notification={notification}
													 markReadNotification={this.markReadNotification}
													 markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof QuoteCommentNotification) {
					return (
						<QuoteCommentCreatedItem key={index}
												 notification={notification}
												 markReadNotification={this.markReadNotification}
												 markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof QuoteStatusChangedNotification) {
					return (
						<QuoteStatusChangedItem key={index}
												notification={notification}
												markReadNotification={this.markReadNotification}
												markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof UserMentionNotification) {
					return (
						<UserMentionItem key={index}
										 notification={notification}
										 markReadNotification={this.markReadNotification}
										 markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof JobStatusNotification) {
					return (
						<NotificationJobStatusItem key={index}
												   notification={notification}
												   markReadNotification={this.markReadNotification}
												   markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof JobReminderNotification) {
					return (
						<NotificationJobReminderItem key={index}
													 notification={notification}
													 onItemLinkClick={this.props.onItemLinkClick}
													 markReadNotification={this.markReadNotification}
													 markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof JobBDPChangeNotification) {
					return (
						<NotificationJobBDPChangedItem key={index}
													   notification={notification}
													   markReadNotification={this.markReadNotification}
													   markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof JobAgentChangeNotification) {
					return (
						<NotificationJobAgentChangedItem key={index}
														 notification={notification}
														 markReadNotification={this.markReadNotification}
														 markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof JobCreatedFromQuoteNotification) {
					return (
						<NotificationJobCreatedFromQuoteItem key={index}
															 notification={notification}
															 markReadNotification={this.markReadNotification}
															 markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof JobWatcherChangeNotification) {
					return (
						<NotificationJobWatcherItem key={index}
													notification={notification}
													markReadNotification={this.markReadNotification}
													markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof JobUserMentionNotification) {
					return (
						<JobUserMentionItem key={index}
											notification={notification}
											markReadNotification={this.markReadNotification}
											markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof BillCreatedNotification) {
					return (
						<NotificationBillCreatedItem key={index}
													 notification={notification}
													 markReadNotification={this.markReadNotification}
													 markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof InvoiceCreatedNotification) {
					return (
						<NotificationInvoiceCreatedItem key={index}
														notification={notification}
														markReadNotification={this.markReadNotification}
														markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof InvoicePaidNotification) {
					return (
						<NotificationInvoicePaidItem key={index}
													 notification={notification}
													 markReadNotification={this.markReadNotification}
													 markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof BillPaidNotification) {
					return (
						<NotificationBillPaidItem key={index}
												  notification={notification}
												  markReadNotification={this.markReadNotification}
												  markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else if (notification instanceof PaymentArrivedNotification) {
					return (
						<NotificationPaymentArrivedItem key={index}
														notification={notification}
														markReadNotification={this.markReadNotification}
														markUnreadNotification={this.markUnreadNotification}/>
					)
				}
				else {
					return null;
				}
			})
		}
		else if (!this.state.isLoading) {
			return [
				<div key={"empty"} className="c-notification-menu_dropdown_body_empty">
					<div>There are no notifications to show</div>
				</div>
			];
		}
		else {
			return []
		}
	}

	markAllNotificationsAsRead() {
		this.props.markAllAsRead(this.visibleFrom, () => {
			if (this.state.filter == FilterState.All) {
				this.setState({notifications: this.state.notifications.map(n => !n.read ? n.setReadStatus(true) : n)})
			}
			else {
				this.setState({page: 0}, this.loadMore);
			}
			api.instance.notificationApi.checkIfAnyNotificationIsUnread(this.visibleFrom)
		});
	}

	/**
	 * Mark notification as read.
	 */
	markReadNotification = (notificationId: string) => {
		this.props.markReadNotification(notificationId, () => this.notificationStatusChangeSuccess(true, notificationId),
			(e) => notifyBugsnagAndShowToast(e, "Mark notification as read"))
	}

	/**
	 * Mark notification as unread.
	 */
	markUnreadNotification = (notificationId: string) => {
		this.props.markUnreadNotification(notificationId, () => this.notificationStatusChangeSuccess(false, notificationId),
			(e) => notifyBugsnagAndShowToast(e, "Mark notification as unread"))
	}

	notificationStatusChangeSuccess = (status: boolean, notificationId: string) => {
		if (this.state.filter == FilterState.All) {
			this.setState(
				{notifications: this.state.notifications.map(n => n.id == notificationId ? n.setReadStatus(status) : n)})
		}
		else {
			this.setState({
				notifications: this.state.notifications.filter(n => n.id != notificationId),
				totalItems: this.state.totalItems - 1
			})
		}
		api.instance.notificationApi.checkIfAnyNotificationIsUnread(this.visibleFrom)
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		markAllAsRead: (visibleFrom: moment.Moment, onSuccess: OnSuccess) => dispatch(
			markAllAsRead(visibleFrom, onSuccess,
				() => Toast.error("Sorry, something went wrong. Try again later.", "Mark notifications as read"))),
		markReadNotification: (notificationId: string, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			markNotificationsAsRead([notificationId], onSuccess, onFailure)),
		markUnreadNotification: ((notificationId: string, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			markNotificationsAsUnread([notificationId], onSuccess, onFailure)))
	}
}

export default withRouter(connect(null, mapDispatchToProps)(NotificationDropdown));